import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const UserNew = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='UserNew' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M18,24 L18,12 M23,22 L13,15 M23,15 L13,22 M8,11 C10.7614237,11 13,8.76142375 13,6 C13,3.23857625 10.7614237,1 8,1 C5.23857625,1 3,3.23857625 3,6 C3,8.76142375 5.23857625,11 8,11 Z M13.0233822,13.0234994 C11.7718684,11.7594056 10.0125018,11 8,11 C4,11 1,14 1,18 L1,23 L11,23' />
  </StyledIcon>
);
